<script lang="ts" setup>
import { computed } from 'vue'
import type { AsyncDataResponse, Props } from './types'
import RecommendationsCarouselV2 from '@/components/RecommendationsCarouselV2/index.vue'

const { $sobreplanosDataService } = useNuxtApp()

const props = defineProps<Props>()

const fetchRecommendedListings = async () => {
  const { data: recommendedListingsResponse, error } = await useAsyncData<AsyncDataResponse>('recommendations', () =>
    $sobreplanosDataService.getListings({
      filters: {
        business_hub: props.businessHub
      },
      refresh: props.refresh
    })
  )

  return { recommendedListingsResponse, error }
}

const logError = (error: any) => {
  const logger = useLogger()
  logger.error({
    message: error.message,
    stack: error
  })
}

const { recommendedListingsResponse, error } = await fetchRecommendedListings()

if (error.value) {
  logError(error.value)
}

const recommendedListings = computed(() => {
  if (error.value) return []

  return recommendedListingsResponse.value.results
})
</script>

<script lang="ts">
export default {
  name: 'PdRecommendationsV2'
}
</script>

<template>
  <RecommendationsCarouselV2
    v-if="recommendedListings.length"
    :listing-id="props.projectCode"
    :business-hubs="props.businessHub"
    :data-attributes="dataAttributes"
    :projects="recommendedListings" />
</template>
